const state = {
  groupId: '',
  playerId: '',
  testId: '',
  time: 0,
  timePass: 0
}

const getters = {
  questionById (state) {
    return function (id) {
      return state.test.test_questions.find(x => x.id === parseInt(id))
    }
  },
  groupId (state) {
    return state.groupId
  },
  playerId (state) {
    return state.playerId
  },
  testId (state) {
    return state.testId
  },
  time (state) {
    return state.time
  },
  timePass (state) {
    return state.timePass
  }
}

const actions = {
  setGroupId ({commit}, id) {
    commit('SET_GROUP_ID', id)
  },
  setPlayerId ({commit}, id) {
    commit('SET_PLAYER_ID', id)
  },
  setTestId ({commit}, id) {
    commit('SET_TEST_ID', id)
  },
  setTime ({commit}, time) {
    commit('SET_TIME', time)
  },
  addTimePass ({commit}) {
    commit('ADD_TIME_PASS')
  }
}

const mutations = {
  SET_GROUP_ID (state, id) {
    state.groupId = id
  },
  SET_PLAYER_ID (state, id) {
    state.playerId = id
  },
  SET_TEST_ID (state, id) {
    state.testId = id
  },
  SET_TEST (state, test) {
    state.test = test
  },
  SET_TIME (state, time) {
    state.time = time
  },
  ADD_TIME_PASS (state) {
    state.timePass++
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/game.js